<div class="At-ChannelPage">

  <button type="button" routerLink="/dashboard/createchannel" class="At-AddBtn"><i class="icon-add"></i></button>

  <!-- Channel SideBar Start  -->
  <aside class="At-ListSideBar">
    <div class="At-PageTitle">
      <h2>Channels</h2>
    </div>
    <form class="At-search">
      <fieldset>
        <div class="At-InputWithIcon">
          <input type="search" class="form-control" placeholder="Search ...">
          <i class="icon-search"></i>
        </div>
      </fieldset>
    </form>
    <div class="At-ChannelsList-Box">
      <accordion [isAnimated]="true">
        <accordion-group>
          <button class="btn btn-link btn-block clearfix At-AccordionBtn" accordion-heading type="button">
            <h3>General Meetings <span class="At-Count">2</span></h3>
            <span class="At-menberinfo"><i class="icon-right-arrow-1"></i>08 Members</span>
          </button>
          <ul class="At-Memberlist">
            <li class="active"><i class="At-StatusCircal"></i>Micheal Decosta</li>
            <li class="active"><i class="At-StatusCircal"></i>Softpetal</li>
            <li class="active"><i class="At-StatusCircal"></i>Jacon</li>
            <li class="active"><i class="At-StatusCircal"></i>Julian</li>
            <li><i class="At-StatusCircal"></i>Annie Mathew</li>
            <li class="active"><i class="At-StatusCircal"></i>Anita Enzo</li>
            <li><i class="At-StatusCircal"></i>Alisha</li>
            <li><i class="At-StatusCircal"></i>Fernando</li>
          </ul>
          <div class="At-BtnArea">
            <button class="At-AddMembers" routerLink="/dashboard/createchannel"><i class="icon-add"></i> add members</button>
          </div>
        </accordion-group>
        <accordion-group>
          <button class="btn btn-link At-AccordionBtn Pastelgreen" accordion-heading type="button">
            <h3>Software Development Team</h3>
            <span class="At-menberinfo"><i class="icon-right-arrow-1"></i>08 Members</span>
          </button>
          <ul class="At-Memberlist">
            <li class="active"><i class="At-StatusCircal"></i>Micheal Decosta</li>
            <li class="active"><i class="At-StatusCircal"></i>Softpetal</li>
            <li class="active"><i class="At-StatusCircal"></i>Jacon</li>
            <li class="active"><i class="At-StatusCircal"></i>Julian</li>
            <li><i class="At-StatusCircal"></i>Annie Mathew</li>
            <li class="active"><i class="At-StatusCircal"></i>Anita Enzo</li>
            <li><i class="At-StatusCircal"></i>Alisha</li>
            <li><i class="At-StatusCircal"></i>Fernando</li>
          </ul>
          <div class="At-BtnArea">
            <button class="At-AddMembers" routerLink="/dashboard/createchannel"><i class="icon-add"></i> add members</button>
          </div>
        </accordion-group>
        <accordion-group>
          <button class="btn btn-link At-AccordionBtn Portage" accordion-heading type="button">
            <h3>Designing Team <span class="At-Count">2</span></h3>
            <span class="At-menberinfo"><i class="icon-right-arrow-1"></i>08 Members</span>
          </button>
          <ul class="At-Memberlist">
            <li class="active"><i class="At-StatusCircal"></i>Micheal Decosta</li>
            <li class="active"><i class="At-StatusCircal"></i>Softpetal</li>
            <li class="active"><i class="At-StatusCircal"></i>Jacon</li>
            <li class="active"><i class="At-StatusCircal"></i>Julian</li>
            <li><i class="At-StatusCircal"></i>Annie Mathew</li>
            <li class="active"><i class="At-StatusCircal"></i>Anita Enzo</li>
            <li><i class="At-StatusCircal"></i>Alisha</li>
            <li><i class="At-StatusCircal"></i>Fernando</li>
          </ul>
          <div class="At-BtnArea">
            <button class="At-AddMembers" routerLink="/dashboard/createchannel"><i class="icon-add"></i> add members</button>
          </div>
        </accordion-group>
        <accordion-group>
          <button class="btn btn-link At-AccordionBtn Dandelion" accordion-heading type="button">
            <h3>Management Team</h3>
            <span class="At-menberinfo"><i class="icon-right-arrow-1"></i>08 Members</span>
          </button>
          <ul class="At-Memberlist">
            <li class="active"><i class="At-StatusCircal"></i>Micheal Decosta</li>
            <li class="active"><i class="At-StatusCircal"></i>Softpetal</li>
            <li class="active"><i class="At-StatusCircal"></i>Jacon</li>
            <li class="active"><i class="At-StatusCircal"></i>Julian</li>
            <li><i class="At-StatusCircal"></i>Annie Mathew</li>
            <li class="active"><i class="At-StatusCircal"></i>Anita Enzo</li>
            <li><i class="At-StatusCircal"></i>Alisha</li>
            <li><i class="At-StatusCircal"></i>Fernando</li>
          </ul>
          <div class="At-BtnArea">
            <button class="At-AddMembers" routerLink="/dashboard/createchannel"><i class="icon-add"></i> add members</button>
          </div>
        </accordion-group>
        <accordion-group>
          <button class="btn btn-link At-AccordionBtn Blueviolet" accordion-heading type="button">
            <h3>Human Resource Dept.</h3>
            <span class="At-menberinfo"><i class="icon-right-arrow-1"></i>08 Members</span>
          </button>
          <ul class="At-Memberlist">
            <li class="active"><i class="At-StatusCircal"></i>Micheal Decosta</li>
            <li class="active"><i class="At-StatusCircal"></i>Softpetal</li>
            <li class="active"><i class="At-StatusCircal"></i>Jacon</li>
            <li class="active"><i class="At-StatusCircal"></i>Julian</li>
            <li><i class="At-StatusCircal"></i>Annie Mathew</li>
            <li class="active"><i class="At-StatusCircal"></i>Anita Enzo</li>
            <li><i class="At-StatusCircal"></i>Alisha</li>
            <li><i class="At-StatusCircal"></i>Fernando</li>
          </ul>
          <div class="At-BtnArea">
            <button class="At-AddMembers" routerLink="/dashboard/createchannel"><i class="icon-add"></i> add members</button>
          </div>
        </accordion-group>
      </accordion>
    </div>
  </aside>
  <!-- Channel SideBar ends  -->

  <!-- Channel Content Start  -->
  <div class="At-ChatContent-area">
    <div class="At-ChatHeader">
      <div class="At-title">
        <h2>Software Development Team</h2>
        <span>Created by <i class="At-date">Julian, Aug 14, 2020</i></span>
      </div>
      <ul class="At-ActionBtns">
        <li><a href="javascript:void(0);" class="At-SquareIcon" routerLink="/audio-call"><i class="icon-phone"></i></a></li>
        <li><a href="javascript:void(0);" class="At-SquareIcon" routerLink="/video-call"><i class="icon-video-camera"></i></a></li>
        <li><a href="javascript:void(0);" class="At-SquareIcon"><i class="icon-speaker"></i></a></li>
        <li><button type="button" (click)="toggleChannel()"><i class="icon-list-view"></i></button></li>
      </ul>
    </div>
    <div class="At-ChatContent">
      <div class="At-InfoBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img01.png" alt="">
            <div class="At-badgePurple">
              <i class="icon-bage"></i>
            </div>
          </figure>
        </div>
        <div class="At-InfoTitle d-flex">
          <div class="At-TitleLeft">
            <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span> <span class="At-Time">10:12</span></h5>
            <h6>Let’s wrap this up quick guys.</h6>
          </div>
        </div>
      </div>
      <div class="At-InfoBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
          </figure>
        </div>
        <div class="At-InfoTitle d-flex">
          <div class="At-TitleLeft">
            <h5>Micheal Decosta . <span>mikkie</span> <span class="At-Time">10:12</span></h5>
            <h6>I have finished the report and will share here in few minutes</h6>
          </div>
        </div>
      </div>
      <div class="At-InfoBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img04.png" alt="">
          </figure>
        </div>
        <div class="At-InfoTitle d-flex">
          <div class="At-TitleLeft">
            <h5>Softpetal:) . <span>floralqueen</span> <span class="At-Time">10:12</span></h5>
            <h6>joined this channel “general meetings”</h6>
          </div>
        </div>
      </div>
      <div class="At-DateBar">
        <span>17th July 2020</span>
      </div>
      <div class="At-InfoBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img01.png" alt="">
            <div class="At-badgePurple">
              <i class="icon-bage"></i>
            </div>
          </figure>
        </div>
        <div class="At-InfoTitle d-flex">
          <div class="At-TitleLeft">
            <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span> <span class="At-Time">10:12</span></h5>
            <h6>Let’s wrap this up quick guys.</h6>
          </div>
        </div>
      </div>
      <div class="At-InfoBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
          </figure>
        </div>
        <div class="At-InfoTitle d-flex">
          <div class="At-TitleLeft">
            <h5>Micheal Decosta . <span>mikkie</span> <span class="At-Time">10:12</span></h5>
            <h6>We are proud to annouce that our last project was successful and we might we give out bonuses to our employees who worked
              so hard for this project.Congras!!!</h6>
          </div>
        </div>
      </div>
      <div class="At-InfoBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img04.png" alt="">
          </figure>
        </div>
        <div class="At-InfoTitle d-flex">
          <div class="At-TitleLeft">
            <h5>Softpetal:) . <span>floralqueen</span> <span class="At-Time">10:12</span></h5>
            <h6>Party ....we need party boss</h6>
          </div>
        </div>
      </div>
      <div class="At-InfoBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img03.png" alt="">
          </figure>
        </div>
        <div class="At-InfoTitle d-flex">
          <div class="At-TitleLeft">
            <h5>Jacob . <span>jazzy</span> <span class="At-Time">10:12</span></h5>
            <h6>yes ... yes .. party!!</h6>
          </div>
        </div>
      </div>
      <div class="At-InfoBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
          </figure>
        </div>
        <div class="At-InfoTitle d-flex">
          <div class="At-TitleLeft">
            <h5>Micheal Decosta . <span>mikkie</span> <span class="At-Time">10:12</span></h5>
            <h6>yes why not.<br>
              what say Julian?</h6>
          </div>
        </div>
      </div>
      <div class="At-InfoBox">
        <div class="At-InfoImg">
          <figure>
            <img src="assets/images/members/member-img01.png" alt="">
            <div class="At-badgePurple">
              <i class="icon-bage"></i>
            </div>
          </figure>
        </div>
        <div class="At-InfoTitle d-flex">
          <div class="At-TitleLeft">
            <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span> <span class="At-Time">10:12</span></h5>
            <h6>Sure, why not. Lets keeo in mind this saturday. I will talk to the upper management.</h6>
          </div>
        </div>
      </div>
    </div>
    <div class="At-ChatFooter">
      <div class="At-TextAndActions">
        <button type="button" class="At-ImprestionBtn"><i class="icon-face-emoji"></i></button>
        <input type="text" class="form-control" placeholder="Say something ...">
        <button type="button" class="At-AttchmentBtn"><i class="icon-attachment"></i></button>
        <button type="button" class="At-SendBtn"><i class="icon-send-1"></i></button>
      </div>
      <button type="button" class="At-VoiceBtn"><i class="icon-mike"></i></button>
    </div>
  </div>
  <!-- Channel Content End  -->

  <!-- Channel Info SideBar Start  -->

  <div class="At-Sidebar At-SidebarActivity At-channelInfoSidebar At-CustomScroll" *ngIf="isChannelInfo">
    <div class="At-SidebarContent">
      <div class="At-CloseSidebar" (click)="toggleChannel()"><i class="icon-cancel"></i></div>
      <div class="At-TabsArea">
        <tabset>
          <tab heading="channel info" id="tab1">
            <div class="At-tabcontent">
              <div class="At-ActivityMiddleInner">
                <a href="javascript:void(0);" class="At-EditBtn"><i class="icon-edit"></i> edit</a>
                <div class="At-ActivityInfoBox">
                  <div class="At-InfoText">
                    <p>Title</p>
                    <h5>General meetings</h5>
                  </div>
                  <div class="At-InfoText">
                    <p>Description</p>
                    <h5>To discuss company wide announcemnts and important memos.</h5>
                  </div>
                  <div class="At-InfoText">
                    <p>Created By:</p>
                    <h5>Julian Warden on 20th July, 2020</h5>
                  </div>
                </div>
              </div>
              <div class="At-ActivityMiddleInner At-MiddleBorderTopBottom">
                <div class="At-SwitchCustom">
                  <span class="At-Mute">Mute Notifications <em>Anyone in your contacts can see and join</em></span>
                  <label class="switch">
                    <input type="checkbox" id="customSwitch1">
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
              <div class="At-ActivityMiddleInner">
                <p class="At-Font16 mb-4">Adminstrator (01)</p>
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure>
                      <img src="assets/images/members/member-img01.png" alt="">
                      <div class="At-badgePurple">
                        <i class="icon-bage"></i>
                      </div>
                    </figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span></h5>
                      <h6>Last Seen 12:09am</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="At-ActivityMiddleInner At-MiddleBorderTopBottom">
                <a href="javascript:void(0);" class="At-EditBtn"><i class="icon-edit"></i> edit</a>
                <p class="At-Font16 mb-4">Members (08)</p>
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure>
                      <img src="assets/images/members/member-img01.png" alt="">
                      <div class="At-badgePurple">
                        <i class="icon-bage"></i>
                      </div>
                    </figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Julian . <span class="At-TextRed">jona </span> . <span class="At-TextRed">coo</span></h5>
                      <h6>Last Seen 12:09am</h6>
                    </div>
                  </div>
                </div>
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure>
                      <img src="assets/images/members/member-img02.png" alt="" class="img-fluid">
                    </figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Micheal Decosta . <span>mikkie</span></h5>
                      <h6>Last Seen 3 hrs ago</h6>
                    </div>
                  </div>
                </div>
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure>
                      <img src="assets/images/members/member-img03.png" alt="">
                    </figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Jacob_98 . <span>jazzy</span></h5>
                      <h6>Last Seen yesterday</h6>
                    </div>
                  </div>
                </div>
                <div class="At-InfoBox">
                  <div class="At-InfoImg">
                    <figure>
                      <img src="assets/images/members/member-img04.png" alt="">
                    </figure>
                  </div>
                  <div class="At-InfoTitle d-flex">
                    <div class="At-TitleLeft">
                      <h5>Softpetal:) . <span>floralqueen</span></h5>
                      <h6>Last Seen yesterday</h6>
                    </div>
                  </div>
                </div>
                <a href="javascript:void(0);" class="At-SeeAllMember">see all members</a>
              </div>
              <div class="At-ActivityMiddleInner At-BorderBottom">
                <div class="At-TitleBox">
                  <h3>Change Tag Color</h3>
                  <div class="At-Colorpickerbox">
                    <span class="At-colorbox"></span>
                    <button> <i class="icon-color-picker"></i></button>
                  </div>
                </div>
              </div>
              <div class="At-ActivityMiddleInner">
                <div class="At-TitleBox">
                  <button class="At-TextRed At-DeletBtn">Delet Channel</button>
                </div>
              </div>
            </div>
          </tab>
          <tab heading="shared media">
            <div class="At-tabcontent">
              <div class="At-ActivityMiddleInner">
                <ul class="At-MediaBox">
                  <li>
                    <figure>
                      <img src="assets/images/posts/media1.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media2.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media3.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media4.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media5.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media6.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media1.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media2.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media3.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media4.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media5.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                  <li>
                    <figure>
                      <img src="assets/images/posts/media6.jpg" alt="" class="img-fluid">
                    </figure>
                  </li>
                </ul>
              </div>
            </div>
          </tab>
        </tabset>
      </div>
    </div>
  </div>
  <!-- Channel Info SideBar End  -->

</div>
